import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class SafeguardingProcessProcessService {
  constructor(private http: HttpClientService) {}

  public updateSafeguardingProcess(params: any): Observable<any> {
    return this.http
      .post("/api/safeguarding_process/update", params)
      .pipe(tap((_) => console.log("SafeguardingProcessService.updateSafeguardingProcess: Ok.")));
  }

  public searchSafeguardingProcess(safeguarding_id: string | number, safeguarding_type: string): Observable<any> {
    const params = {
      safeguarding_id: safeguarding_id,
      safeguarding_type: safeguarding_type,
    };
    return this.http
      .post("/api/safeguarding_process/search", params)
      .pipe(tap((_) => console.log("SafeguardingProcessProcessService.searchSafeguardingProcess: Ok.")));
  }
}
